import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchContactList } from "../actions/contact";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";

const ContactList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { contactList } = useSelector((state) => state.contactReducer);
  //breadcrumb
  const translateModule = "contact";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchContactList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    // if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/contact-edit/` + params.data.id}
        // deleteItemId={params.data.id}
        // deleteItemTitle={`${params.data.firstName} ${params.data.lastName}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    // dispatch(deleteUser(pageId));
  };

  const columnDefs = [
    {
      headerName: "Ime i prezime",
      field: "name",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Email adresa",
      field: "email",
      filter: "agTextColumnFilter",
      width: 160,
    },
    {
      headerName: "Naslov",
      field: "subject",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Tekst poruke",
      field: "message",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.4",
        alignItems: "center",
        display: "flex",
      },
    },
    createDateColumn("Datum kreiranja", "createdAt"),
    // {
    //   headerName: "Aktivan",
    //   field: "active",
    //   filter: "agSetColumnFilter",
    //   cellRenderer: statusRender,
    //   maxWidth: 180,
    //   valueGetter: (params) => {
    //     if (params.data?.active === true) return "Aktivan";
    //     if (params.data?.active === false) return "Neaktivan";
    //     return "";
    //   },
    // },
    // {
    //   headerName: "",
    //   field: "custom",
    //   cellRenderer: customCellRenderer,
    //   pinned: "right",
    //   width: 90,
    // },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchContactList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={contactList}
        columnDefs={columnDefs}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="contact-list"
      />
    </Fragment>
  );
};

export default ContactList;
